import moment from 'moment';

export const formatTimeSyncVoyageTemplate = (value: string | null): string => {
	return value ? moment(value).format('HH:mm') : '—'
}

export const formatDaySyncVoyageTemplate = (value: string | null): string => {
	return value ? moment(value).format('dd DD.MM') : '—'
}

export const formatLongDaySyncVoyageTemplate = (value: string | null): string => {
	if (!value) {
		return '—'
	}
	const text = moment(value).format('dddd, D MMMM')
	return text.charAt(0).toUpperCase() + text.slice(1)
}

export const formatRangeSyncVoyageTemplate = (start: string | null, end: string | null): string => {
	return `${formatTimeSyncVoyageTemplate(start)}–${formatTimeSyncVoyageTemplate(end)}`
}
